import { useId as useReactId } from 'react'

// fix W3C issue : https://github.com/facebook/react/issues/26839
export const useId = () => {
  const id = useReactId()
  return id.replace(/:/g, '_')
}
